__turbopack_context__.v({
  "Date": "c2QGoW_Date",
  "DateMobile": "c2QGoW_DateMobile",
  "SingleArticlePage": "c2QGoW_SingleArticlePage",
  "dealsPageFullWidth": "c2QGoW_dealsPageFullWidth",
  "mobileSocialShare": "c2QGoW_mobileSocialShare",
  "post-subtitle": "c2QGoW_post-subtitle",
  "post-title": "c2QGoW_post-title",
  "promoted": "c2QGoW_promoted",
  "readnext": "c2QGoW_readnext",
  "separator--promoted": "c2QGoW_separator--promoted",
  "single-article-info": "c2QGoW_single-article-info",
  "singleArticleHero": "c2QGoW_singleArticleHero",
  "socialshare": "c2QGoW_socialshare",
  "tagsContainer": "c2QGoW_tagsContainer",
});
